import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';

import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TripZone } from '@shared/models';

@Component({
  selector: 'app-zones',
  templateUrl: './zones.page.html',
  styleUrls: ['./zones.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
})
export class ZonesPage implements OnInit {
  zones: TripZone[] = [];
  loadingZones: boolean = false;

  constructor(private apiService: ApiService, private router: Router, private dataService: DataService) {}

  ngOnInit() {
    this.getZones();
  }

  getZones() {
    this.loadingZones = true;
    this.apiService
      .getData('zones')
      .then((res) => {
        console.log('zones: ', res);
        this.zones = res.data;
      })
      .finally(() => {
        this.loadingZones = false;
      });
  }

  goRoutes(zone: TripZone) {
    console.log('goRoute with zone ', zone.id);
    this.dataService.setData('zone', zone);
    this.router.navigate(['/tecservice-transportec/transportec/routes']);
  }
}
